import { ArrowForward, ContentCopyOutlined } from '@mui/icons-material';
import { Button, CircularProgress, IconButton, InputAdornment, TextField } from '@mui/material';
import * as R from 'ramda';
import { useNavigate } from 'react-router-dom';
import { useWall } from '../../App';
import { getApiNfts } from '../../pages/About';
import { INVALID_WALLET_ADDRESS } from '../../pages/constants';
import { isValidAddress } from '../../utils';
import { sizes } from '../../variables';
import { ETH_ADDRESS_REGEX, INVALID_CLIPBOARD_CONTENT } from './constants';

const AddressField = ({ label = 'Wallet Address', half }) => {
  const { walletAddress, setWalletAddress, setSnackbar, setNfts, setLoading, loading, mobile, setCustomAddress } = useWall();
  const navigate = useNavigate();

  const getClipboardContent = async () => await window.navigator.clipboard.readText();
  const isAddressValid = content => ETH_ADDRESS_REGEX.test(content);

  const paste = async () => {
    const content = await getClipboardContent();
    const isValid = isAddressValid(content);

    if (isValid) {
      setWalletAddress(content);
      return;
    }
    setSnackbar({
      show: true,
      content: INVALID_CLIPBOARD_CONTENT,
      severity: "warning",
    });
  }

  const PasteButton = () => {
    if (mobile || half) {
      return <IconButton
        aria-label='Paste address from clipboard'
        onClick={paste}
      >
        <ContentCopyOutlined />
      </IconButton>
    }
    return <Button variant="text" size="large" fullWidth onClick={paste} aria-label="Paste address from clipboard">
      paste your address
      <ContentCopyOutlined sx={{ marginLeft: sizes.xs2 }} />
    </Button>
  }

  const createWall = async () => {
    if (!isValidAddress(walletAddress)) {
      return setSnackbar({
        show: true,
        content: INVALID_WALLET_ADDRESS,
        severity: 'error'
      })
    }
    const nfts = await getApiNfts({ address: walletAddress, setLoading, setSnackbar, loading });
    setNfts(nfts);
    setCustomAddress(walletAddress);
    navigate("/wall");
  }

  const ButtonContent = ({ mobile }) => {
    if (loading) {
      return <CircularProgress
        color="primary"
        size={sizes.sm}
        sx={{ marginLeft: !mobile && sizes.xs2, fontSize: sizes.sm }}
      />
    }
    return <ArrowForward sx={{ marginLeft: !mobile && sizes.xs2, fontSize: sizes.sm }} />
  }


  const CreateWallButton = () => {
    if (mobile || half) {
      return <IconButton
        onClick={createWall}
      >
        <ButtonContent mobile />
      </IconButton>
    }
    return <Button variant="text" size="large" fullWidth onClick={createWall} aria-label="Creates custom wall using wallet address">
      {loading ? 'Creating a custom wall for you' : 'create your wall'}
      <ButtonContent />
    </Button>
  }

  const AdornmentContent = () => {
    if (R.isEmpty(walletAddress)) return <PasteButton />
    return <CreateWallButton />
  }

  return <TextField
    color="primary"
    fullWidth
    label={label}
    onChange={({ target }) => setWalletAddress(target.value)}
    value={walletAddress || ''}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <AdornmentContent />
        </InputAdornment>
      ),
    }}
  />
}

export default AddressField;